import React from 'react'
import { SimpleGrid } from '@chakra-ui/react'
import StatCard from './StatCard'
import { CoinData } from '../types'
import { formatCurrency, formatPrice } from '../utils'

interface MarketDataPanelProps {
  data: CoinData
  gridTemplateColumns: number | undefined
  statCardBg: string
}

const MarketDataPanel = ({ data, gridTemplateColumns, statCardBg }: MarketDataPanelProps) => (
  <SimpleGrid columns={gridTemplateColumns || 1} spacing={4} mb={6}>
    <StatCard
      label="Market Cap"
      value={formatCurrency(data.market_data.market_cap.usd)}
      helpText={`${data.market_data.market_cap_change_percentage_24h.toFixed(2)}% (24h)`}
      arrowType={data.market_data.market_cap_change_percentage_24h >= 0 ? 'increase' : 'decrease'}
      bg={statCardBg}
    />

    <StatCard
      label="24h Volume"
      value={formatCurrency(data.market_data.total_volume.usd)}
      bg={statCardBg}
    />

    <StatCard
      label="24h High"
      value={formatPrice(data.market_data.high_24h.usd)}
      bg={statCardBg}
    />

    <StatCard
      label="24h Low"
      value={formatPrice(data.market_data.low_24h.usd)}
      bg={statCardBg}
    />

    <StatCard
      label="All Time High"
      value={formatPrice(data.market_data.ath.usd)}
      bg={statCardBg}
    />

    <StatCard
      label="All Time Low"
      value={formatPrice(data.market_data.atl.usd)}
      bg={statCardBg}
    />

    <StatCard
      label="Fully Diluted Valuation"
      value={formatCurrency(data.market_data.fully_diluted_valuation.usd)}
      bg={statCardBg}
    />
  </SimpleGrid>
)

export default MarketDataPanel
